import * as React from "react";
import { ObservableValue } from "azure-devops-ui/Core/Observable";
import { TriStateCheckbox } from "azure-devops-ui/Checkbox";

const tristateCheckbox = new ObservableValue<boolean | undefined>(undefined);

export default class TriStateCheckboxExample extends React.Component {
    public render(): JSX.Element {
        return (
            <TriStateCheckbox
                label="Tri-state checkbox"
                checked={tristateCheckbox}
                onChange={(event, checked) => (tristateCheckbox.value = checked)}
                triState={true}
            />
        );
    }
}
